import type { FC } from "react";
import type { SpecialComponents } from "react-markdown/lib/ast-to-react";
import type { NormalComponents } from "react-markdown/lib/complex-types";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGFM from "remark-gfm";

import { isExternalLink } from "utils/is-external-link";

interface MarkdownProps {
  className?: string;
  text: string;
}

const commonComponents: Partial<
  Omit<NormalComponents, keyof SpecialComponents>
> = {
  a: ({ children, href }) => (
    <a
      href={href}
      target={isExternalLink(href) ? "_blank" : undefined}
      rel={isExternalLink(href) ? "noopener noreferrer" : undefined}
      className="text-primary no-underline hover:underline"
    >
      {children}
    </a>
  ),
};

export const Markdown: FC<MarkdownProps> = ({ className, text }) => {
  return (
    <ReactMarkdown
      className={`prose ${className}`}
      components={commonComponents}
      remarkPlugins={[remarkGFM]}
    >
      {text}
    </ReactMarkdown>
  );
};
